// extracted by mini-css-extract-plugin
export default {"outer":"DataGeneratorManagement_outer__GBTBP","filter":"DataGeneratorManagement_filter__ykjt4"};